const TableContent = [
  {
    ArtistName: "@olivia",
    ArtistImg: "Person.png",
    StashName: "Patty O’Furniture",
    StashImg: "Person-1.png",
    Season: "Season 14",
    Date: "22 Jan 2020, 00:00",
    EditionNFT: "@olivia",
    NumberEdition: "10",
  },
  {
    ArtistName: "@phoenix",
    ArtistImg: "Person-2.png",
    StashName: "A. Mused",
    StashImg: "Person-3.png",
    Season: "Season 8",
    Date: "09 Oct 2020, 00:00",
    EditionNFT: "@phoenix",
    NumberEdition: "12",
  },
  {
    ArtistName: "@lana",
    ArtistImg: "Person-4.png",
    StashName: "Ray O’Sun",
    StashImg: "Person-5.png",
    Season: "Season 7",
    Date: "01 May 2021, 00:00",
    EditionNFT: "@lana",
    NumberEdition: "08",
  },
  {
    ArtistName: "@demi",
    ArtistImg: "Person-6.png",
    StashName: "Ray Sin",
    StashImg: "Person-7.png",
    Season: "Season 17",
    Date: "27 Jun 2021, 00:00",
    EditionNFT: "@demi",
    NumberEdition: "12",
  },
  {
    ArtistName: "@candice",
    ArtistImg: "Person-8.png",
    StashName: "Hope Furaletter",
    StashImg: "Person-9.png",
    Season: "Season 3",
    Date: "05 Jun 2021, 00:00",
    EditionNFT: "@candice",
    NumberEdition: "22",
  },
  {
    ArtistName: "@natali",
    ArtistImg: "Person-10.png",
    StashName: "Clyde Stale",
    StashImg: "Person-11.png",
    Season: "Season 4",
    Date: "19 Apr 2021, 00:00",
    EditionNFT: "@natali",
    NumberEdition: "9",
  },
];
export { TableContent };
